.persona-widget__iframe {
  width: 800px;
  height: 1000px;
}

@media (max-width: 733px) {
  .persona-widget__iframe {
    width: 100%;
    height: 100%;
  }
}
